const cameraTypes = [
  {
    id: "actuate",
    name: "ACTUATE",
  },
  {
    id: "faceme",
    name: "FACEME",
  },
  {
    id: "scylla",
    name: "SCYLLA",
  },
];

export default cameraTypes;
